// @ts-strict-ignore
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Icon } from '@node-space/ui-components'
import { CustomerWallet } from 'types/customers'
import { WalletTransactionExportModal } from './WalletTransactionExportModal'

interface WalletTransactionExportProps {
  downloadAll?: boolean
  customerWallet?: CustomerWallet
}

export const WalletTransactionExport = ({
  downloadAll,
  customerWallet,
}: WalletTransactionExportProps) => {
  const { t } = useTranslation()

  const [showCustomDateExportModal, setShowCustomDateExportModal] = useState(false)

  const btnTxt = downloadAll ? t('exports.exportButton') : t('exports.export')

  const handleClose = () => {
    setShowCustomDateExportModal(false)
  }

  return (
    <>
      {showCustomDateExportModal && (
        <WalletTransactionExportModal
          handleClose={handleClose}
          downloadAll={downloadAll}
          customerWallet={customerWallet}
        />
      )}
      <Button
        variant="secondary"
        iconElement={<Icon name="DownloadSimple" />}
        onClick={() => setShowCustomDateExportModal(true)}
        testId="export-wallet-transactions-btn"
      >
        {btnTxt}
      </Button>
    </>
  )
}
